import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { UntypedFormGroup, Validators, UntypedFormArray, UntypedFormBuilder } from '@angular/forms';
import { Location } from '@angular/common';
import * as _ from 'lodash';
import { ModalComponent } from '../../modal/modal.component';
import { TimeToRepairPluginService } from '../timetorepair/timetorepair-plugin.service';
import { TotalTimeToRepairPluginService } from './totaltimetorepair-plugin.service';
import { BaseModalPageComponent } from '../../base-modal.component';
import { ConfirmComponent } from '../../modal/confirm.component';

@Component({
    selector: 'totaltimetorepair-edit',
    templateUrl: './totaltimetorepair-edit.component.html',
    standalone: false
})
export class TotalTimeToRepairEditPageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  pluginId: string;
  public plugin: any;
  public currentItem: any;
  editForm: UntypedFormGroup;
  public processing = false;

  @ViewChild('reparatorModal', { static: true })
  modal: ModalComponent;
  public totalTimeToRepairs: any;
  @ViewChild('menuModal', { static: true })
  menuModal: ModalComponent;
  @ViewChild('deleteConfirm', { static: true })
  deleteConfirm: ConfirmComponent;
  public reparators: any;

  public sumTimeToRepairs: any[];

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private timeToRepairService: TimeToRepairPluginService,
    private service: TotalTimeToRepairPluginService,
    location: Location,
    private cdRef: ChangeDetectorRef,
    private fb: UntypedFormBuilder
  ) {
    super(location);
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.goToBack();

      this.pluginId = pluginId;

      this.initData();
    });
  }

  save(model: any) {
    this.processing = true;
    this.service
      .updateTotalTimeToRepair(
        this.inspectionId,
        this.pluginId,
        _.map(model.totaltimetorepairs, (el: any) => ({
          Reparator: el.Reparator,
          Count: el.Count,
          Days: el.Days
        }))
      )
      .subscribe((el) => {
        this.processing = false;
        this.goToBack();
      });
  }

  cancel() {
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
  }

  initData() {
    this.reparators = _.orderBy(this.timeToRepairService.getReparators(), ['label']);
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.totalTimeToRepairs =
        this.plugin.config.TotalTimeToRepairs != null
          ? this.plugin.config.TotalTimeToRepairs.map((el: any) => {
              return {
                Reparator: el.Reparator,
                Days: el.Days,
                Count: el.Count
              };
            })
          : [];
      this.initForm();
      this.cdRef.detectChanges();
    });
    this.service.sumTimeToRepairs(this.inspectionId).subscribe((ttr) => {
      this.sumTimeToRepairs = ttr;
    });
  }

  get formData() {
    return <UntypedFormArray>this.editForm.controls['totaltimetorepairs'];
  }

  remove(i: number) {
    const control = <UntypedFormArray>this.editForm.controls['totaltimetorepairs'];
    control.removeAt(i);
  }

  public openReparatorSelector(selectedIndex: number, i: number): void {
    this.openSelector(this.modal, this.reparators, selectedIndex || selectedIndex === 0 ? selectedIndex : -1);
    const control = <UntypedFormArray>this.editForm.controls['totaltimetorepairs'];
    this.currentItem = control.controls[i];
  }

  public selectReparatorMenu(item: any) {
    const selectedIndex = this.currentItem.controls['Reparator'].value === item.selectedIndex ? '' : item.selectedIndex;
    this.currentItem.controls['Reparator'].setValue(selectedIndex);
  }

  add() {
    const control = <UntypedFormArray>this.editForm.controls['totaltimetorepairs'];
    control.push(this.initTotalTimeToRepair());
  }

  initTotalTimeToRepair(el?: any) {
    let reparator = '';
    if (el) {
      reparator = this.timeToRepairService.getReparators().some((r) => r.value === el.Reparator) ? el.Reparator : '';
    }
    return this.fb.group({
      Reparator: [reparator, Validators.required],
      Days: [el ? el.Days : 0],
      Count: [el ? el.Count : 0]
    });
  }

  initForm() {
    this.editForm = this.fb.group({
      totaltimetorepairs: this.fb.array([])
    });
    const control = <UntypedFormArray>this.editForm.controls['totaltimetorepairs'];
    _.forEach(this.totalTimeToRepairs, (el) => {
      control.push(this.initTotalTimeToRepair(el));
    });
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 10:
        this.gotoEditPage();
        break;
      default:
    }
  }

  gotoEditJsonPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      -1,
      'plugins',
      this.pluginId,
      'editjson'
    ]);
  }

  gotoEditPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      -1,
      'plugins',
      this.pluginId,
      'edit'
    ]);
  }

  openDeleteConfirm() {
    this.deleteConfirm.open();
  }

  deletePlugin(e: any) {
    this.service.deletePlugin(this.inspectionId, null, this.pluginId).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }
}
